module.exports = __webpack_public_path__ + "assets/img/hcpbt3.05219425.png";